import { RichText, useBlockProps } from '@wordpress/block-editor';
import classnames from 'classnames';
import './style.scss';
const agentImage = require('./images/user.jpg');

export default function save({ attributes }) {
	const {
		buttonSize,
		buttonType,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		buttonLinkTarget,
		visibility,
		iconTarget,
		iconBackground,
		imageUrl,
		messengerUserName,
		timeZone,
		mondayStart,
		mondayEnd,
		tuesdayStart,
		tuesdayEnd,
		wednesdayStart,
		wednesdayEnd,
		thursdayStart,
		thursdayEnd,
		fridayStart,
		fridayEnd,
		saturdayStart,
		saturdayEnd,
		sundayStart,
		sundayEnd,
		borderRadius,
		buttonIconBorder,
		icon_borderRadius,
		buttonPadding,
		buttonBorder,
		bgColor,
		bgHoverColor,
		textColor,
		textHoverColor,
		iconColor,
		iconHoverColor,
		iconBgColor,
		iconBgHoverColor,
	} = attributes;
	const textClasses = classnames(`mSupportButtons-align-${textAlignment}`);
	const basicBtn = classnames(` mSupportButtons mSupport_button block_btn`);
	const classes = classnames(
		`mSupportButtons mSupport_button mSupport_button_advance block_btn`
	);

	return (
		<>
			{buttonType === 'basic-button' ? (
				<div className={`button-wrapper ${textClasses}`}>
					<a
						{...useBlockProps.save({
							className: `${basicBtn} ${visibility}`,
						})}
						style={{
							'--mSupport-padding': `${buttonPadding.top} ${buttonPadding.right} ${buttonPadding.bottom} ${buttonPadding.left}`,
							'--mSupport-btn-scale': `${buttonSize}`,
							'--mSupport-border-radius': `${borderRadius}px`,
							'--mSupport-border': `${buttonBorder?.width} ${buttonBorder?.style} ${buttonBorder?.color}`,
							'--mSupport-icon-border': `${buttonIconBorder?.width} ${buttonIconBorder?.style} ${buttonIconBorder?.color}`,
							'--mSupport-icon-border-radius': `${icon_borderRadius}px`,
							'--mSupport-background': `${bgColor}`,
							'--mSupport-hover-background': `${bgHoverColor}`,
							'--mSupport-text-color': `${textColor}`,
							'--mSupport-text-hover-color': `${textHoverColor}`,
							'--mSupport-icon-normal-color': `${iconColor}`,
							'--mSupport-icon-hover-color': `${iconHoverColor}`,
							'--mSupport-icon-normal-bg-color': `${iconBgColor}`,
							'--mSupport-icon-hover-bg-color': `${iconBgHoverColor}`,
						}}
						data-btnavailablety={`{ "monday":"${mondayStart}-${mondayEnd}", "tuesday":"${tuesdayStart}-${tuesdayEnd}", "wednesday":"${wednesdayStart}-${wednesdayEnd}", "thursday":"${thursdayStart}-${thursdayEnd}", "friday":"${fridayStart}-${fridayEnd}", "saturday":"${saturdayStart}-${saturdayEnd}", "sunday":"${sundayStart}-${sundayEnd}" }`}
						data-timezone={timeZone}
						{...({ 'data-group': messengerUserName })}
							href={`https://wa.me/${messengerUserName}`}
							rel="noopener noreferrer"
							target={buttonLinkTarget ? '_blank' : '_self'}
							>
						{iconTarget && (
							<div
							className={`bubble__icon ${iconBackground === true ? 'icon_bg' : ''}`}
							>
								<span className="dashicons dashicons-format-status"></span>
							</div>
						)}
						<RichText.Content tagName="span" value={text} />
					</a>
				</div>
			) : (
				<div className={`button-wrapper ${textClasses}`}>
					<div
						{...useBlockProps.save({
							className: `${classes} ${visibility}`,
						})}
						style={{
							'--mSupport-padding': `${buttonPadding.top} ${buttonPadding.right} ${buttonPadding.bottom} ${buttonPadding.left}`,
							'--mSupport-btn-scale': `${buttonSize}`,
							'--mSupport-border-radius': `${borderRadius}px`,
							'--mSupport-border': `${buttonBorder?.width} ${buttonBorder?.style} ${buttonBorder?.color}`,
							'--mSupport-icon-border': `${buttonIconBorder?.width} ${buttonIconBorder?.style} ${buttonIconBorder?.color}`,
							'--mSupport-icon-border-radius': `${icon_borderRadius}px`,
							'--mSupport-background': `${bgColor}`,
							'--mSupport-hover-background': `${bgHoverColor}`,
							'--mSupport-text-color': `${textColor}`,
							'--mSupport-text-hover-color': `${textHoverColor}`,
						}}
						data-btnavailablety={`{ "monday":"${mondayStart}-${mondayEnd}", "tuesday":"${tuesdayStart}-${tuesdayEnd}", "wednesday":"${wednesdayStart}-${wednesdayEnd}", "thursday":"${thursdayStart}-${thursdayEnd}", "friday":"${fridayStart}-${fridayEnd}", "saturday":"${saturdayStart}-${saturdayEnd}", "sunday":"${sundayStart}-${sundayEnd}" }`}
						data-timezone={timeZone}
						{...({ 'data-group': messengerUserName })}
					>
						<img
							src={imageUrl ? imageUrl : agentImage}
							alt="agent"
						/>
						<div className="info-wrapper">
							<RichText.Content
								value={info}
								tagName="div"
								className="info"
							/>
							<RichText.Content
								value={title}
								tagName="div"
								className="mSupport_title"
							/>
							<RichText.Content
								value={online}
								tagName="div"
								className="online"
							/>
							<RichText.Content
								value={offline}
								tagName="div"
								className="offline"
							/>
						</div>
						<a
							href={`https://wa.me/${messengerUserName}`}
							rel="noopener noreferrer"
							target={buttonLinkTarget ? '_blank' : '_self'}
						></a>
					</div>
				</div>
			)}
		</>
	);
}
